import { useState, useRef, useEffect } from "react";
import "../../assets/css/StatusDropdown.css";
import AnalysisDiagnostic from "./AnalysisDiagnostic.jsx";
import { getHistoryPresentation } from "../../utils/resultPresentation.js";

const STATUSES = [
  { value: "2", key: "RÉUSSI", icon: "bi-check-circle", label: "Réussi" },
  { value: "3", key: "RAPPEL", icon: "bi-telephone-inbound", label: "Rappel" },
  { value: "4", key: "OCCUPÉ", icon: "bi-telephone-x", label: "Occupé" },
  { value: "5", key: "RÉPONDEUR", icon: "bi-mic", label: "Répondeur" },
  { value: "1",key: "PAS_INT",icon: "bi-hand-thumbs-down",label: "Pas intéressé",},
  { value: "6", key: "SVI", label: "SVI", icon: "bi-telephone-inbound-fill", label:"Serveur Vocal"  },
  { value: "7", key: "AMD_RÉPONDEUR", icon: "bi-telephone-inbound-fill", label: "Répondeur Asterisk" },
  { value: "8", key: "HORS_CIBLE", icon: "bi-slash-circle", label: "Hors Cible" }
];

export default function StatusDropdown({ itemId, status, historyRecord, disabled = false, onStatusChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const presentation = getHistoryPresentation({ ...historyRecord, status });

  useEffect(() => {
    const handler = (e) => {
      if (!ref.current?.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div className="status-dropdown-wrap" ref={ref}>
      <AnalysisDiagnostic record={historyRecord} />
      <button type="button" disabled={disabled}
        aria-haspopup="menu" aria-expanded={open} aria-label="Modifier la qualification enregistrée"
        className={`historiqueBadge ${presentation.qualificationClass} clickable border-0 ${open ? "open" : ""}`}
        onClick={(e) => {
          e.stopPropagation();
          setOpen((v) => !v);
        }}
      >
        {presentation.diagnostic && !presentation.derived && "Qualification enregistrée : "}
        {presentation.qualification}
        <i className="bi bi-chevron-down ms-1" style={{ fontSize: "10px" }} />
      </button>

      {open && (
        <div className="status-dropdown">
          {STATUSES.map((s) => (
            <div
              key={s.value}
              className={`status-option ${s.key} ${status === s.value ? "active" : ""}`}
              onClick={(e) => {
                e.stopPropagation();
                if (!disabled) onStatusChange(itemId, s.value);
                setOpen(false);
              }}
            >
              <i className={`bi ${s.icon}`} />
              {s.label}
              {status === s.value && <i className="bi bi-check ms-auto" />}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
